import { API_BASE_URL } from './apiConfig';
import { ApiClientOptions } from '../common/types';

const apiClient = async (endpoint: string, options?: ApiClientOptions) => {
	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options?.headers,
	};

	const response = await fetch(`${API_BASE_URL}${endpoint}`, {
		...options,
		headers,
	});

	if (!response.ok) {
		const errorData = await response.json();
		const error = new Error(errorData.detail || 'API Error');
		(error as any).statusCode = response.status;
		throw error;
	}

	return response.json();
};

export default apiClient;
